<template>
  <LargeModal
    :show="show"
    title="Create engagement"
    subtitle="Create a new engagement to find and book guides for your next trip"
    @close="$emit('close')"
  >
    <div class="space-y-6 sm:space-y-5">
      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
        <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Description </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <textarea
            v-model="form.description"
            :class="{'border-red-300': form.errors.description }"
            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
          />
          <p
            v-if="form.errors.description"
            class="mt-2 text-sm text-red-600"
          >
            {{ form.errors.description }}
          </p>
        </div>
      </div>

      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
        <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Destination </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <DestinationSelectPicker
            v-model="form.place"
          />
          <p
            v-if="form.errors.place_id"
            class="mt-2 text-sm text-red-600"
          >
            {{ form.errors.place_id }}
          </p>
        </div>
      </div>

      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
        <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Language </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <LanguageSelectPicker
            v-model="form.language"
            label=""
          />
          <p
            v-if="form.errors.language_id"
            class="mt-2 text-sm text-red-600"
          >
            {{ form.errors.language_id }}
          </p>
        </div>
      </div>

      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
        <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Period </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <Datepicker
            v-model="form.range"
            range
          />
          <p
            v-if="form.errors.starts_at || form.errors.ends_at"
            class="mt-2 text-sm text-red-600"
          >
            {{ form.errors.starts_at }}
            {{ form.errors.ends_at }}
          </p>
        </div>
      </div>

      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
        <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Group size </label>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <input
            id="pax"
            v-model="form.pax"
            name="pax"
            type="number"
            class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
            placeholder="No. of pax"
          >
          <p
            v-if="form.errors.pax"
            class="mt-2 text-sm text-red-600"
          >
            {{ form.errors.pax }}
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <UploadButton
        class="m-2 absolute left-2"
      />
      <CreateButton
        class="m-2"
        @click="save"
      />
      <CancelButton
        class="m-2"
        @click="close"
      />
    </template>
  </LargeModal>
</template>

<script>

import Datepicker from '@vuepic/vue-datepicker';
import LargeModal from '@/ComponentsDeprecated/Modal/LargeModal.vue';
import CancelButton from '@/ComponentsDeprecated/Buttons/CancelButton';
import CreateButton from '@/ComponentsDeprecated/Buttons/CreateButton';
import UploadButton from '@/ComponentsDeprecated/Buttons/UploadButton';
import CurrencyPicker from '@/ComponentsDeprecated/CurrencyPicker';
import SearchDestinationsSelect from '@/ComponentsDeprecated/SearchDestinationsSelect';
import LanguagePicker from '@/ComponentsDeprecated/LanguagePicker';
import LanguageSelectPicker from '@/ComponentsDeprecated/Select/LanguageSelectPicker';
import DestinationSelectPicker from '@/ComponentsDeprecated/Select/DestinationSelectPicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  components: {
    DestinationSelectPicker,
    LanguageSelectPicker,
    LargeModal,
    CurrencyPicker,
    SearchDestinationsSelect,
    LanguagePicker,
    Datepicker,
    CancelButton,
    CreateButton,
    UploadButton,
  },
  props: [
    'show',
  ],
  data() {
    return {
      form: this.$inertia.form({
        description: '',
        place: null,
        place_id: null,
        language: null,
        language_id: null,
        range: [new Date(), new Date()],
        starts_at: null,
        ends_at: null,
        pax: null,
      }),
    };
  },
  methods: {
    save() {
      this.form.starts_at = this.form.range[0];
      this.form.ends_at = this.form.range[1];
      this.form.language_id = this.form.language.id;
      this.form.place_id = this.form.place.id;
      this.form.post(route('engagements.store'), {
        errorBag: 'storeOffer',
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.$emit('close');
        },
      });
    },
    close() {
      this.$emit('close');
      this.form.reset();
    },
  },

};
</script>
